import React, { useEffect, useRef } from "react";

// Replace values with your real AdSense publisher ID and ad slot IDs from the AdSense console
const PUBLISHER_ID = "ca-pub-7567218936368250";

export const AD_SLOTS = {
  feed: "8110679443",
  detail: "6797597774",
};

interface AdSenseBannerProps {
  slot: string;
  style?: React.CSSProperties;
}

const AdSenseBanner: React.FC<AdSenseBannerProps> = ({ slot, style }) => {
  const ref = useRef<HTMLModElement>(null);

  useEffect(() => {
    try {
      // Push the ad after the component mounts so the <ins> tag is in the DOM
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push(
        {},
      );
    } catch (_) {}
  }, []);

  return (
    <div style={{ textAlign: "center", overflow: "hidden", ...style }}>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={PUBLISHER_ID}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSenseBanner;
